import styled from 'styled-components'

import { Card } from '../../../components/card/Card'

import { Color } from '../../../theme/color'

export function QuestionCard({
  isChecked,
  isAnswer,
  children,
}: {
  isChecked: boolean
  isAnswer: boolean | undefined
  children: React.ReactNode
}) {
  return (
    <Container
      isChecked={isChecked}
      isAnswer={isAnswer}
      $border={true}
      $borderWidth={1}
      $radius={8}
      $borderColor="gray_2"
    >
      {children}
    </Container>
  )
}

const Container = styled(Card.styled)<{ isChecked: boolean; isAnswer: boolean | undefined }>`
  ${({ isAnswer, isChecked }) =>
    typeof isAnswer === 'undefined'
      ? isChecked && `background-color: ${Color.gray_1};`
      : isAnswer
        ? `border-color: ${Color.primary_5}; background-color: ${Color.primary_1};`
        : `border-color: ${Color.error}; background-color: ${Color.error_light};`}
  input[type='radio'] {
    display: none;
  }
`
